import { useQuery } from '@tanstack/react-query';
import styles from './TeamGameTable.module.css';
import { getUrl } from '../../App';

const fetch_games = async (event_id) => {
    const response = await fetch(`${getUrl()}/api/games?is_testgame=false&event=${event_id}`, { credentials: 'include', });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
}

const fetch_teams = async () => {
    const response = await fetch(`${getUrl()}/api/teams/`, { credentials: 'include', });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
}



export const GameTable = ({ event, team }) => {

    const games = useQuery({
        queryKey: ['games', event.id],
        queryFn: () => fetch_games(event.id),
        staleTime: 5 * 60 * 1000,
        cacheTime: 5 * 60 * 1000,
    });

    const teams = useQuery({
        queryKey: ['teams'],
        queryFn: () => fetch_teams(),
        staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
        cacheTime: 5 * 60 * 1000,
    });

    const filter_games = (team_id) => {
        if (!games || !games.data) return [];

        return games.data.filter((game) =>
            (game.team1 === team_id || game.team2 === team_id) && game.half === "half1"
        );
    };

    if (games.isLoading || teams.isLoading) {
        return (
            <div className="view-content">
                <div className="panel-header">
                    <h3>Team Detail View</h3>
                </div>
            </div >
        )
    }

    const teamGames = filter_games(team.id);

    return (
        <div className={styles.card_section}>
            <div className={styles.card_header}>
                <h3>{event.name}</h3>
            </div>

            <div className={styles.card_content}>
                {teamGames.length === 0 ? (
                    <p className={styles.no_games}>No games found for this team.</p>
                ) : (
                    <table className={styles.game_table}>
                        <thead>
                            <tr>
                                <th>Time</th>
                                <th>Team 1</th>
                                <th>Team 2</th>
                                <th>Score</th>
                                <th>Recordings half1</th>
                                <th>Recordings half2</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[...teamGames].sort((a, b) => new Date(a.start_time) - new Date(b.start_time)).map((game) => {
                                const half2Game = games.data.find(g =>
                                    g.half === "half2" &&
                                    g.team1 === game.team1 &&
                                    g.team2 === game.team2 &&
                                    g.start_time === game.start_time
                                );

                                return (
                                    <tr key={game.id} className={styles.table_row}>
                                        <td>{new Date(game.start_time).toLocaleString('sv-SE', {
                                            year: 'numeric',
                                            month: '2-digit',
                                            day: '2-digit',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: false
                                        }).replace(',', '')}</td>

                                        <td className={game.team1 === team.id ? styles.highlighted_team : ''}>
                                            {teams.data.find(team => team.id === game.team1)?.name}
                                        </td>

                                        <td className={game.team2 === team.id ? styles.highlighted_team : ''}>
                                            {teams.data.find(team => team.id === game.team2)?.name}
                                        </td>
                                        <td>{game.score}</td>
                                        <td>
                                            {game.recordings.sort((a, b) => {
                                                if (a.type < b.type) return 1;
                                                if (a.type > b.type) return -1;
                                                return 0;
                                            }).map((recording) => (
                                                <a
                                                    key={recording.video_path}
                                                    href={"https://logs.berlin-united.com/" + recording.video_path}
                                                    className={styles.recording_link}

                                                >
                                                    {recording.type}
                                                </a>
                                            ))}
                                        </td>
                                        <td>
                                            {half2Game?.recordings?.sort((a, b) => {
                                                if (a.type < b.type) return 1;
                                                if (a.type > b.type) return -1;
                                                return 0;
                                            }).map((recording) => (
                                                <a
                                                    key={recording.url}
                                                    href={recording.url}
                                                    className={styles.recording_link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {recording.type}
                                                </a>
                                            ))}                 </td>

                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};


